<template>
  <section>
    <time-line :target="user.email"></time-line>
    <el-card :header="$t('userInfoCardDevicesHeaderText', { devicesCount })" data-qa="Content-UserInfo-Card-Devices" v-loading="loading">
      <div v-if="devicesCount > 0">
        <p :key="`${device.id}-${index}`" v-for="(device, index) in devices">
          <router-link :data-qa="`Content-UserInfo-DeviceLink-${device.id}`" :to="`/device/${device.id}`" replace>{{ device.id }}</router-link>
        </p>
      </div>
      <div v-else>
        <span>{{ $t('userInfoCardDevicesEmptyText') }}</span>
      </div>
    </el-card>
    <el-card :header="$t('userInfoCardGroupsHeaderText', { groupsCount })" data-qa="Content-UserInfo-Card-Groups" v-loading="loading">
      <div v-if="groupsCount > 0">
        <p :key="`${group.name}-${index}`" v-for="(group, index) in groups">{{ getGroupName(group) }}</p>
      </div>
      <div v-else>
        <span>{{ $t('userInfoCardGroupEmptyText') }}</span>
      </div>
    </el-card>
  </section>
</template>

<script>
  import main from './UserInfo.js'
  export default main
</script>

<style lang="scss" scoped>
  @import './UserInfo.scss'
</style>



// WEBPACK FOOTER //
// UserInfo.vue?72e6dbfc